import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { motion } from "framer-motion";

interface AirdropButtonProps {
  loading: boolean;
  isCancelled: boolean;
  amount: number;
  disabled: boolean;
  onClick: () => void;
}

export function AirdropButton({
  loading,
  isCancelled,
  amount,
  disabled,
  onClick,
}: AirdropButtonProps) {
  return (
    <motion.div
      whileHover={{ scale: 1.01 }}
      whileTap={{ scale: 0.99 }}
      className="pt-2"
    >
      <Button
        className={cn(
          "w-full h-14 relative",
          "bg-gradient-to-r from-[#9945FF] to-[#00D18C] hover:opacity-90",
          "text-white text-base sm:text-lg font-medium transition-all duration-200",
          "shadow-lg hover:shadow-xl hover:shadow-[#9945FF]/20",
          "after:absolute after:inset-0 after:bg-gradient-to-r after:from-transparent after:via-[#ffffff]/10 after:to-transparent after:opacity-0 after:hover:opacity-100 after:transition-opacity after:duration-500",
          "overflow-hidden rounded-lg"
        )}
        onClick={onClick}
        disabled={disabled}
      >
        {loading ? (
          <div className="flex items-center justify-center gap-2">
            <Loader2 className="h-5 w-5 animate-spin" />
            <span>
              {isCancelled ? "Cancelling..." : `Requesting ${amount} SOL...`}
            </span>
          </div>
        ) : (
          <span>Request {amount} SOL Airdrop</span>
        )}
      </Button>
    </motion.div>
  );
}
